import { render, staticRenderFns } from "./FormCategoryModal.vue?vue&type=template&id=13b2ebb2&scoped=true&"
import script from "./FormCategoryModal.vue?vue&type=script&lang=js&"
export * from "./FormCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./FormCategoryModal.vue?vue&type=style&index=0&id=13b2ebb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b2ebb2",
  null
  
)

export default component.exports